import { render } from "./CrearPreguntas.vue?vue&type=template&id=4b56b707"
import script from "./CrearPreguntas.vue?vue&type=script&lang=js"
export * from "./CrearPreguntas.vue?vue&type=script&lang=js"

import "./CrearPreguntas.vue?vue&type=style&index=0&id=4b56b707&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__